<template>
  <div class="labels-container" :class="{ 'single-line': singleLine }">
    <label v-if="!hideLabel">{{ IDPrefix }} ID</label>

    <div class="id-copy-field">
      <span :id="`${type}-id-${parseId(id)}-val`">{{ parseId(id) }}</span>
      <Tooltip :placement="'top-start'" :trigger="'click'">
        <template #body>
          <pre>{{ IDPrefix }} ID copied</pre>
        </template>
        <SVGIcon
          v-tooltip="`Copy ${IDPrefix} ID to clipboard`"
          class="icon copy"
          :iconName="'copy'"
          :width="'16px'"
          :height="'16px'"
          @click.stop="copyToClipboard(parseId(id))"
        />
      </Tooltip>
    </div>
  </div>
</template>

<script setup>
import {
  ref, toRefs,
} from 'vue';
import SVGIcon from '@/components/SVGIcon.vue';
import Tooltip from "@/components/Tooltip.vue";

const props = defineProps({
  id: {
    type: Number,
    default: 0,
  },
  type: {
    type: String,
    default: '',
  },
  hideLabel: {
    type: Boolean,
    default: false,
  },
  singleLine: {
    type: Boolean,
    default: false,
  },
});

const IDPrefix = ref(null);

const {
  id,
  type,
  singleLine,
} = toRefs(props);

function parseId() {
  if (id.value && type.value) {
    let prefix = '';
    switch (type.value) {
    case 'task':
      prefix = 'bt';
      IDPrefix.value = "Task";
      break;
    case 'dataset':
      prefix = 'ds';
      IDPrefix.value = "Dataset";
      break;
    case 'annotation set':
      prefix = 'as';
      IDPrefix.value = "Annotation Set";
      break;
    case 'annotation':
      prefix = 'a';
      IDPrefix.value = "Annotation";
      break;
    case 'image':
      prefix = 'i';
      IDPrefix.value = "Image";
      break;
    case 'trainer':
      prefix = 't';
      IDPrefix.value = "Session";
      break;
    case 'validator':
      prefix = 'v';
      IDPrefix.value = "Session";
      break;
    case 'project':
      prefix = 'p';
      IDPrefix.value = "Project";
      break;
    case 'experiment':
      prefix = 'exp';
      IDPrefix.value = "Experiment";
      break;
    case 'auto annotation':
      prefix = 'inf';
      IDPrefix.value = "Session";
      break;
    default:
      prefix = '';
    }
    let result = '';
    if (prefix !== '') {
      result = `${prefix}-${Number(id.value).toString(16)}`;
    } else {
      result = Number(id.value).toString(16);
    }

    return result;
  }
  return '';
}

function copyToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text);
  }
}

</script>

<style lang="scss" scoped>
.labels-container {
  display: flex;
  flex-direction: column;
  label {
    font-size: 0.8rem;
    font-weight: 550;

    &.hide {
      visibility: hidden;
    }
  }

  .id-copy-field {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: var(--body-text-color);
    gap: 8px;

    span {
      font-size: 0.85rem;
    }
  }

  .icon {
    margin: 0 5px 0 0;
    cursor: pointer;
    &.copy{
      color: #999;
      &:hover {
        color: #666;
      }
    }
  }

  &.single-line {
    flex-direction: row;
    align-items: center;
    gap: 12px;
    width: 100%;
    margin-top: 6px;
    margin-bottom: 4px;

    label {
      white-space: nowrap;
      flex: 0 0 auto;
    }

    .id-copy-field {
      flex: 1;
    }
  }
}
</style>
